var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 23.08 17.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#2f363f;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-274.54 -398.68)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 270.05,
    y: 391.21,
    width: 32.05,
    height: 32.05
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M297.61,407.85a.13.13,0,0,0,0-.06s0,0,0-.06h0L296.17,405l0,0,0-.05-.05,0-.06,0h-5.35v-3.17h0s0,0,0-.06,0-.05,0-.06v0l-1.41-2.69s0,0,0,0l-.05-.05a.1.1,0,0,0-.05,0l-.05,0h-6l-.06,0-.05,0,0,.05,0,0-1.41,2.69v0s0,0,0,.06,0,0,0,.06h0v1.52h-5.22l-.06,0-.05,0,0,0,0,0-1.41,2.69h0l0,.06s0,0,0,.06v9.28a.32.32,0,0,0,.32.32h22.43a.32.32,0,0,0,.33-.32v-7.63m-1.92-2.35,1.07,2.05h-6.12V405.5Zm-12.39-6.18h5.42l1.07,2.05h-7.56Zm-1.92,6.58h-6l1.07-2h4.92Zm-6.2.64h6.2v8.62h-6.2Zm6.84-.32V402h8v13.15h-8Zm15,8.94h-6.33v-7H297Z",
    transform: "translate(-274.54 -398.68)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.c0f995f5b9a5d646b27645a7423cf74b.svg";
export { ForwardRef as ReactComponent };